<template>
  <notification-item :message="message" @delete-item="deleteItem" @close="close">
    <template v-slot:title>
      <span>{{ $t('_.title') }}</span>
    </template>
    <p>{{ $t(['_.statusMessage', isLeader ? 'leader' : 'member'], { title, teamName }) }}</p>
    <p>{{ $t(['_.detailMessage', isLeader ? 'leader' : 'member']) }}</p>
    <CountDown :time="Number(waitingStart)" :expired-desc="$t('_.started')" />
    <template v-slot:buttons>
      <button @click="goCheckIn">{{ $t(`_.${realTime ? 'realTimeButton' : 'button'}.${isLeader ? 'leader' : 'member'}.${isPassed ? 'already' : 'yet'}`) }}</button>
    </template>
  </notification-item>
</template>

<script>
import Specific from '@shared/types/Specific';
import CountDown from '@shared/components/common/CountDown.vue';
import NotificationItem from '@shared/components/notification/NotificationItem.vue';
import { isPassed } from '@shared/utils/timeUtils';

export default {
  name: 'TournamentCheckinWillStartItem',
  components: { NotificationItem, CountDown },
  lexicon: 'shared.notification.TOURNAMENT_CHECKIN_WILL_START',
  props: {
    message: Specific,
  },
  computed: {
    application() {
      return this.message?.data?.application || {};
    },
    tournament() {
      return this.message?.data?.tournament || {};
    },
    notificationId() {
      return this.message?.userNotificationId;
    },
    team() {
      return this.message?.data?.team || {};
    },
    title() {
      return this.tournament.title || this.$t('anonymous.arena');
    },
    teamName() {
      return this.team.name || this.$t('anonymous.team');
    },
    waitingStart() {
      return this.tournament.waitingStart;
    },
    isPassed() {
      return this.waitingStart ? isPassed(this.$store, this.waitingStart) : true;
    },
    isLeader() {
      const leaderIds = this.application.leaderIds || [];
      const userId = this.message?.userId;
      return leaderIds.includes(userId);
    },
    realTime() {
      return Boolean(this.message?.realTime);
    },
  },
  methods: {
    goCheckIn() {
      const { tournamentId, gameId, isWcgArena } = this.tournament;
      this.routeMainPath({ path: `${this.$i18n('path')}/arena/${isWcgArena ? 'wcg/' : ''}${tournamentId || gameId}${this.isPassed ? '' : '?checkin=true'}` });
      this.$emit('read-item', this.message || {});
    },
    deleteItem(notificationId) {
      this.$emit('delete-item', notificationId);
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
